export default __webpack_public_path__ + "static/media/back-2.7dcbc489.svg";